import { getObjectEntries } from "../../../../../../shared/utils/objects";
import { InitialAccessLevel } from "../../types";


export const accessLevelNames: { [level in InitialAccessLevel]: string } = {
    [InitialAccessLevel.Full]: "Full",
    [InitialAccessLevel.Agronomist]: "Agronomist",
    [InitialAccessLevel.Operator]: "Operator",
}

export const accessLevelOptions = getObjectEntries(accessLevelNames)
